import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import 'froala-editor/js/froala_editor.pkgd.min.js';
import ReactDOM from 'react-dom/client';
import App from './App';
import './fabric.min.css';

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/css/third_party/spell_checker.min.css';


import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/table.min.js';
// import 'froala-editor/js/third_party/spell_checker.min.js'

import '../node_modules/font-awesome/css/font-awesome.min.css';
import '../node_modules/underscore/underscore-min.js';
import FrameBuster from './FrameBuster.jsx';
import { loadRuntimeConfig } from './configLoader';

initializeIcons();


if (window.location.href.includes('gizmo-widget')) {
  document.body.classList.add('augmento-main-body');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const isFrameBusterEnabled = import.meta.env.VITE_ENABLE_FRAMEBUSTER === 'true';
loadRuntimeConfig().then(() => {
  root.render(
    <>{
      window.location.pathname.includes("/ping") ?
        <div>OK</div> :
        <> {isFrameBusterEnabled && <FrameBuster />}<App /></>
    }
    </>
  );
});
